import { render, staticRenderFns } from "./JianKang_DataCenter.vue?vue&type=template&id=f3f27f1c&scoped=true"
import script from "./JianKang_DataCenter.vue?vue&type=script&lang=js"
export * from "./JianKang_DataCenter.vue?vue&type=script&lang=js"
import style0 from "./JianKang_DataCenter.vue?vue&type=style&index=0&id=f3f27f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f27f1c",
  null
  
)

export default component.exports